package com.castly.admin.ui

import androidx.compose.runtime.*
import com.castly.admin.api.ApiClient
import com.castly.admin.ui.readers.ReaderListPage
@Composable
fun ReadersSection(apiClient: ApiClient) {
    ReaderListPage(apiClient)
}
